document.addEventListener('DOMContentLoaded', () => {
  const welcomeModal = document.querySelector('[data-welcome-modal]');
  const welcomeStorageKey = 'lineupLeagueWelcomeDismissed';

  if (welcomeModal) {
    let hasSeenWelcome = false;
    try {
      hasSeenWelcome = window.localStorage.getItem(welcomeStorageKey) === 'true';
    } catch (error) {
      hasSeenWelcome = false;
    }

    const closeWelcome = () => {
      welcomeModal.hidden = true;
      document.body.classList.remove('modal-open');
      try {
        window.localStorage.setItem(welcomeStorageKey, 'true');
      } catch (error) {}
    };

    if (!hasSeenWelcome) {
      welcomeModal.hidden = false;
      document.body.classList.add('modal-open');
    }

    welcomeModal.querySelectorAll('[data-welcome-close]').forEach((button) => {
      button.addEventListener('click', closeWelcome);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !welcomeModal.hidden) closeWelcome();
    });
  }

  const menuButton = document.querySelector('.menu-button');
  const navigation = document.querySelector('#PrimaryNavigation');

  if (menuButton && navigation) {
    menuButton.addEventListener('click', () => {
      const isOpen = navigation.classList.toggle('nav-open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });
  }

  document.querySelectorAll('[data-athlete-showcase]').forEach((showcase) => {
    const tabs = showcase.querySelectorAll('[data-athlete-tab]');
    const media = showcase.querySelector('[data-spotlight-media]');
    const sticker = showcase.querySelector('[data-spotlight-sticker]');
    const fields = {
      name: showcase.querySelector('[data-name]'),
      initials: showcase.querySelector('[data-initials]'),
      events: showcase.querySelector('[data-events]'),
      energy: showcase.querySelector('[data-energy]'),
      achievement: showcase.querySelector('[data-achievement]'),
      dimensions: showcase.querySelector('[data-dimensions]'),
      price: showcase.querySelector('[data-price]'),
      productLink: showcase.querySelector('[data-product-link]'),
      profileLink: showcase.querySelector('[data-profile-link]')
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-pressed', 'false');
        });
        tab.classList.add('active');
        tab.setAttribute('aria-pressed', 'true');

        Object.entries(fields).forEach(([key, element]) => {
          if (!element || ['productLink', 'profileLink'].includes(key)) return;
          element.textContent = tab.dataset[key] || '';
        });

        if (fields.productLink) fields.productLink.href = tab.dataset.productUrl || '/collections/all';
        if (fields.profileLink) {
          fields.profileLink.href = tab.dataset.profile || '#';
          fields.profileLink.hidden = !tab.dataset.profile;
        }
        if (sticker) {
          sticker.src = tab.dataset.sticker || '';
          sticker.alt = `${tab.dataset.name || 'Athlete'} collectible sticker`;
        }
        if (media) {
          const shade = '<div class="media-shade"></div>';
          const initials = `<span class="spotlight-index" data-initials>${tab.dataset.initials || ''}</span>`;
          if (tab.dataset.video) {
            media.innerHTML = `<video autoplay muted loop playsinline preload="metadata" poster="${tab.dataset.sticker}"><source src="${tab.dataset.video}" type="video/mp4"></video>${shade}${initials}`;
          } else {
            media.innerHTML = `<img src="${tab.dataset.photo}" alt="${tab.dataset.name} competing" width="1200" height="1500" loading="lazy">${shade}${initials}`;
          }
        }
      });
    });
  });
});
